<template>
  <div>
    <div v-for="(accommodation, index) in accommodation_list" :key="_uid+'accommodation'+index">
      <tabbed-info
        v-if="accommodation.servizi.length"
        :id="`service:${index}`"
        :items="map_tabbed_info(accommodation.servizi)"
      />
    </div>
  </div>
</template>

<script>
import TabbedInfo from '@alpitour/components/blocks/detail/tabbed-info.vue';

export default {
  name: 'accommodations',
  components: {
    'tabbed-info': TabbedInfo,
  },
  props: {
    // prop per uso dinamico in detail-price (pattern detail_blocks)
    statics_detail: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    accommodation_list() {
      if (this.statics_detail) {
        const first = Object.values(this.statics_detail)[0]
        if (first && first.schedaProdotto) {
          const { sistemazioni = [] } = first.schedaProdotto
          return sistemazioni.map((sistemazione) => ({
            ...sistemazione,
            servizi: sistemazione.servizi || [],
          }))
        }
      }
      return []
    },
  },
  methods: {
    map_tabbed_info(items) {
      return items.map((service) => ({
        title: service.titolo_servizi_struttura,
        body: service.descrizione_servizi_struttura,
      }))
    }
  }
}
</script>

<style lang="scss">
  .information .vb-tabs {
    margin-top: $grid-gutter-width*2;
  }
</style>
